import { IPaginatedResponse } from '../../types/paginated-response.type'
import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import {
  IProductDetails,
  IProductItem,
  IProductList,
  IProductsDashboard,
} from './products.types'

export class Products extends ServiceBase {
  public async getDashboard(): Promise<IProductsDashboard> {
    const url = `/item/finished/dashboard`
    const response = await this.request.get<IProductsDashboard, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getList(
    page: number,
    limit?: number,
    search?: string,
    brand?: string,
  ): Promise<IPaginatedResponse<IProductList[]>> {
    const url = `/item/finished/list`
    const response = await this.request.get<
      IPaginatedResponse<IProductList[]>,
      IError
    >(url, {
      params: {
        page: page,
        limit: limit || 10,
        search: search || undefined,
        brand: brand,
      },
    })

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getDetails(code: string): Promise<IProductDetails> {
    const url = `/item/finished/${code}/details`
    const response = await this.request.get<IProductDetails, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getItems(
    code: string,
    search?: string,
    startDate?: Date,
    endDate?: Date,
  ): Promise<IPaginatedResponse<IProductItem[]>> {
    const url = `/item/finished/${code}/items`
    const response = await this.request.get<
      IPaginatedResponse<IProductItem[]>,
      IError
    >(url, {
      params: {
        page: 1,
        limit: 100,
        search: search || undefined,
        startDate: startDate || undefined,
        endDate: endDate || undefined,
      },
    })

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
